import { createTheme } from "@mui/material";
export const primaryColor = "#215aa9";
export const tertiaryColor = "#9774a8";
export const secondaryColor = "#ffc61e";
export const darkColor = "#141d2a";

export const antdTheme = {
  token: {
    colorPrimary: primaryColor,
  },
  components: {
    Button: {
      // primaryColor: "#000",
      // colorTextLightSolid: "#000",
      //   colorPrimaryHover: darkColor,
    },
  },
};

export const themeMui = createTheme({
  palette: {
    // mode: "dark",
    primary: {
      main: primaryColor,
    },
  },
  typography: {
    // fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 13,
    button: {
      textTransform: "none",
    },
  },
});
